/**
 * CurrencyConverter entity class
 */

/**
 * CurrencyConverterFactory
 * returns CurrencyConverter entity class
 *
 * @class CurrencyConverterFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.CurrencyConverter} class
 *
 * @ngdoc factory
 * @name mwApp.factory:CurrencyConverterFactory
 */
/* @ngInject */
export default function CurrencyConverterFactory ($http, alertLiteSvc, Entity, Type, onOffMixin) {
  /* === CurrencyConverter class === */

  /**
   * CurrencyConverter model
   *
   * @class CurrencyConverter
   * @classdesc CurrencyConverter model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing CurrencyConverter entity fields
   * @return {models.CurrencyConverter} CurrencyConverter entity
   */
  function CurrencyConverter () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  CurrencyConverter.prototype = Object.create(Entity.prototype)
  CurrencyConverter.prototype.constructor = CurrencyConverter

  /* === CurrencyConverter instance methods & fields === */

  Object.assign(CurrencyConverter.prototype, {

    /**
     * instance fields
     *
     * @memberof models.CurrencyConverter#
     * @type {Object}
     */
    _fields: {
      id: Number,
      refreshRateSec: Type({ from: n => n / 60, to: n => n * 60 }), // auto convert seconds <-> minutes
      token: String,
      requestsCount: String,
      enabled: Boolean,
      defaultConverter: Boolean,
      useSystemDefault: Boolean,
      currencyConverterType: String // CURRENCY_CONVERTER_TYPES
    },

    /**
     * url template
     *
     * @memberof models.CurrencyConverter#
     * @type {String}
     */
    _urlTemplate: 'api/currencyconverters/{{::id}}',

    /**
     * Set CurrencyConverter as default (or not default), performing PATCH request to the server
     *
     * @memberof models.CurrencyConverter#
     * @return {Promise} promise
     */
    _default: function (setDefault) {
      return $http.patch(this._url, setDefault !== false ? '"MAKE_DEFAULT"' : '"MAKE_NOT_DEFAULT"')
        .then(
          response => {
            this._weakCopy(response.data)
            return response
          }
        ).catch(
          rejection => {
            this.useSystemDefault = setDefault === false
            return alertLiteSvc.alertError(rejection)
          }
        )
    }

  }, onOffMixin)

  /* === CurrencyConverter static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(CurrencyConverter, Entity)
  CurrencyConverter._name = 'CurrencyConverter'
  CurrencyConverter._publicName = 'Currency Converter'
  CurrencyConverter.init()

  // permissions
  CurrencyConverter.access = {
    view: 'viewNetworkPayment viewGlobalPayment |',
    // create: 'createPayment',
    edit: 'editNetworkPayment editGlobalPayment |'
    // delete: 'deletePayment'
  }

  return CurrencyConverter
}
